import Vue from 'vue'

export const ToastBus = new Vue()

const DEFAULT_DURATION = 2800

export function showToast (message, duration = DEFAULT_DURATION) {
  if (!message) return
  ToastBus.$emit('toast:show', {
    message: String(message),
    duration: Number(duration) > 0 ? Number(duration) : DEFAULT_DURATION
  })
}
